module.exports = __webpack_public_path__ + "img/smart-scan-3.34fc174e.png";